/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TaskDtoTaskType = (typeof TaskDtoTaskType)[keyof typeof TaskDtoTaskType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskDtoTaskType = {
  NOTE_WITH_TODO: 'NOTE_WITH_TODO',
  THERAPY_COMPLIANCE_OVERDUE: 'THERAPY_COMPLIANCE_OVERDUE',
  APPOINTMENT_TODAY: 'APPOINTMENT_TODAY',
  TEST_RESULT_INCOMPLETE: 'TEST_RESULT_INCOMPLETE',
  TRACING_WAITING_PERIOD_OVER: 'TRACING_WAITING_PERIOD_OVER',
} as const;
